// redux/slices/generalOptionsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../helpers/commonFunctions";

// Generic thunk to fetch public API options dynamically
export const reqToGetGeneralOptions = createAsyncThunk(
  "generalOptions/reqToGetGeneralOptions",
  async ({ name }, thunkAPI) => {
    try {
      let options = [];

      if (name === "timezones") {
        const response = await axios.get(
          "https://restcountries.com/v3.1/all?fields=timezones"
        );
        const tzSet = new Set();

        response.data.forEach((country) => {
          if (country.timezones) {
            country.timezones.forEach((tz) => tzSet.add(tz));
          }
        });

        options = Array.from(tzSet).map((tz) => ({
          value: tz,
          label: tz,
        }));
      } else if (name === "currencies") {
        const response = await axios.get(
          "https://restcountries.com/v3.1/all?fields=currencies"
        );
        const currencySet = new Set();
        response.data.forEach((country) => {
          if (country.currencies) {
            Object.entries(country.currencies).forEach(([code, info]) => {
              currencySet.add(`${code} (${info.symbol || ""})`);
            });
          }
        });
        options = Array.from(currencySet).map((cur) => ({
          value: cur,
          label: cur,
        }));
      } else if (name === "languages") {
        const response = await axios.get(
          "https://restcountries.com/v3.1/all?fields=languages"
        );
        const languageSet = new Set();
        response.data.forEach((country) => {
          if (country.languages) {
            Object.values(country.languages).forEach((lang) =>
              languageSet.add(lang)
            );
          }
        });
        options = Array.from(languageSet).map((lang) => ({
          value: lang,
          label: lang,
        }));
      } else {
        throw new Error("Invalid name parameter");
      }

      return { name, options };
    } catch (error) {
      notify(`Failed to fetch ${name}`, "error");
      return thunkAPI.rejectWithValue(error?.message || "Network Error");
    }
  }
);

const generalOptionsSlice = createSlice({
  name: "generalOptions",
  initialState: {
    loader: false,
    timezones: [],
    currencies: [],
    languages: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(reqToGetGeneralOptions.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToGetGeneralOptions.fulfilled, (state, action) => {
        state.loader = false;
        const { name, options } = action.payload;
        state[name] = options;
      })
      .addCase(reqToGetGeneralOptions.rejected, (state, action) => {
        state.loader = false;
        state.error = action.payload;
      });
  },
});

export default generalOptionsSlice.reducer;
